<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>CC {{$route.params.ccType}} Docs</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="row mt-3">
              <div class="col-md-2">
                <label>SHIPPER VGM</label>
                <div v-if="vgmUploadView.length>0">
                  <div class="row" v-for="(item,index) in vgmUploadView" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item!='' && item!=null"
                        :href="`${docURL}/CC_Export_Uploads/`+item"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>SHIPPING BILL</label>
                <div v-if="sbUploadView.length>0">
                  <div class="row" v-for="(item1,index) in sbUploadView" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item1!='' && item1!=null"
                        :href="`${docURL}/CC_Export_Uploads/`+item1"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
              <div class="col-md-2">
                <label>DELIVERY ORDER</label>
                <div v-if="doUploadView.length>0">
                  <div class="row" v-for="(item10,index) in doUploadView" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item10!='' && item10!=null"
                        :href="`${docURL}/CC_Import_Uploads/`+item10"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>

              <div class="col-md-3">
                <label>APPROVED CHECK LIST</label>
                <div v-if="approveCheckUploadView.length>0">
                  <div class="row" v-for="(item3,index) in approveCheckUploadView" :key="index">
                    <div class="col-md-12">
                      <a
                        v-if="item3!='' && item3!=null"
                        :href="`${docURL}/CC_Export_Uploads/`+item3"
                        target="_blank"
                        download
                      >View Document - {{index+1}}</a>
                      <span v-else class="error">Document Not Uploaded</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span class="error">Document Not Uploaded</span>
                </div>
              </div>
            </div>

            <div class="row mt-3" v-if="importEntryPageDoc.length>0">
              <div class="col-md-2" v-for="(item4,index) in importEntryPageDoc" :key="index">
                <label style=" text-transform: uppercase !important;">{{item4.trackingDoc}}</label>
                <div class="col-md-12">
                  <a
                    style="margin-left:-15px"
                    :href="`${docURL}/CC_Import_Uploads/`+item4.trackDocUpload"
                    target="_blank"
                    download
                  >View Document</a>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="alertAddSeaImp"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$route.params.ccExportId != undefined &&
      this.$route.params.ccExportId != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
      isLoading: true,
      docURL: URL_BASE_DOC,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      shipperVgmDoc: "",
      shippingBillDoc: "",
      deliveryOrderDoc: "",
      approvedCheckListDoc: "",
      importEntryPageDoc: []
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor
  },
  computed: {
    vgmUploadView() {
      return this.shipperVgmDoc != "" && this.shipperVgmDoc != null
        ? this.shipperVgmDoc.split(",")
        : [];
    },
    sbUploadView() {
      return this.shippingBillDoc != "" && this.shippingBillDoc != null
        ? this.shippingBillDoc.split(",")
        : [];
    },
    doUploadView() {
      return this.deliveryOrderDoc != "" && this.deliveryOrderDoc != null
        ? this.deliveryOrderDoc.split(",")
        : [];
    },

    approveCheckUploadView() {
      return this.approvedCheckListDoc != "" &&
        this.approvedCheckListDoc != null
        ? this.approvedCheckListDoc.split(",")
        : [];
    }
  },

  methods: {
    previousFFView() {
      window.history.go(-1);
    },
    getData() {
      this.isLoading = true;

      let vehicle_drive = {
        itemCode: "itemCode",
        ccImportId: this.$route.params.ccExportId,
        ccType: this.$route.params.ccType
      };
      console.log(vehicle_drive);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/getDataCCDocs.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (data.ediExecutionPageDoc.length > 0) {
              this.shipperVgmDoc = data.ediExecutionPageDoc[0].vgmUpload;
              this.shippingBillDoc = data.ediExecutionPageDoc[0].uploadBoe;
              this.approvedCheckListDoc =
                data.ediExecutionPageDoc[0].checklistUpload;
            }
            if (data.importEntryPageDoc.length > 0) {
              this.importEntryPageDoc = data.importEntryPageDoc;
            }
            if (data.importExecutionPageDoc.length > 0) {
              this.deliveryOrderDoc = data.importExecutionPageDoc[0].uploadDo;
            }

            this.isLoading = false;
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ccDocListPage.vue?73e6e0b4